<p-toast [style]="{marginTop: '80px'}">
</p-toast>
@if (formLoading) {
  <div class="progress-spinner">
    <app-spinner [formLoading]="formLoading"></app-spinner>
  </div>
}
<div class="container-fluid glb-popup">
  <div class="d-flex justify-content-between align-items-center mt-2">
    <div>
      @if (formReadOnly) {
        <h3> {{inbox.subject}}</h3>
      }
      @if (!formReadOnly) {
        <h2> {{formTitle}}</h2>
      }
    </div>
  </div>
  <div class="m-2 d-flex justify-content-between align-items-center">
    <div class="me-4">
      <div class="my-1">
        <span class="fw-bold">From : </span>{{ inbox?.senderMobileNum }} {{ inbox?.senderName }}
      </div>
      <div class="my-1">
        <span class="fw-bold">To : </span>{{ inbox?.msgRecipientAPIList[0]?.mobileNum }}
      </div>
      <!-- <div class="my-1" *ngIf="isSendEnable">
      <span class="fw-bold">Subject : </span>{{ inbox?.subject }}
    </div> -->
    @if (isSendEnable) {
      <div class="my-1">
        <span class="fw-bold">Message Sent : </span>{{ inbox?.mobileText }}
      </div>
    }
  </div>
  <div>
    <div class="my-1 fw-bold text-nowrap">{{ inbox?.createDate |date:'medium' }}</div>
    <div>
      @if (inbox?.topic == 100 && inbox?.topicId) {
        <div>
          @if (!openingReservation[inbox?.topicId]) {
            <span class="link fw-bold blink-text" (click)="openReservation(inbox?.topicId)"
            >Rez : #{{inbox?.topicId}}</span>
          }
          @if (openingReservation[inbox?.topicId]) {
            <i class="pi pi-spinner pi-spin"></i>
          }
        </div>
      }
    </div>
  </div>
</div>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
@if (showClose) {
  <button mat-icon-button [mat-dialog-close]="showClose"
    style="float:right;top:-50px;background-color: transparent;">
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
}
<hr>

  <!-- SMS Chat Conversation UI -->
  @if (inboxId) {
    <div class="sms-chat-container mb-3">
      <div id="sms-chat-messages" class="sms-chat-messages" (scroll)="onScrollUp($event)">
        <!-- Loading indicator at top when loading more messages -->
        @if (loadingConversation && currentPage > 0) {
          <div class="text-center py-2">
            <i class="pi pi-spin pi-spinner"></i> <span style="font-size: 12px;">Loading more messages...</span>
          </div>
        }
        <!-- Loading indicator for initial load -->
        @if (loadingConversation && currentPage === 0 && conversationMessages.length === 0) {
          <div class="text-center py-4">
            <i class="pi pi-spin pi-spinner"></i> <span style="font-size: 12px;">Loading conversation...</span>
          </div>
        }
        <!-- Empty state -->
        @if (!loadingConversation && conversationMessages.length === 0) {
          <div class="text-center py-4 text-muted">
            <span style="font-size: 12px;">No messages in this conversation</span>
          </div>
        }
        <!-- Chat Messages -->
        @for (message of conversationMessages; track message; let i = $index) {
          <div
            class="sms-message"
            [ngClass]="{'sms-sent': (message.direction === 'OUTGOING'), 'sms-received': !(message.direction === 'OUTGOING')}">
            <div class="sms-message-bubble">
              <div class="sms-message-header">
                <span class="sms-sender-name">{{ message.direction === 'OUTGOING' ? 'You' : (message.mobileNumber || 'Unknown') }}</span>
                <span class="sms-message-time">{{ formatMessageDate(message.messageDateTime) }}</span>
              </div>
              <div class="sms-message-content">{{ message.mobileText || '' }}</div>
              @if (message.smsAttachments?.length) {
                <div class="sms-message-attachments">
                  @for (att of message.smsAttachments; track att) {
                    <div
                      class="sms-attachment-pill"
                      (click)="openSmsAttachment(att)"
                      title="Open attachment in new tab">
                      <i class="pi pi-paperclip" aria-hidden="true"></i>
                      <span class="sms-attachment-name">
                        {{ att.fileName || att.filename || 'Attachment' }}
                      </span>
                    </div>
                  }
                </div>
              }
              @if (message.msgId && (message.msgRecipientId || message.msgReciepentId || message.msgRecipientAPIId)) {
                <div class="sms-message-meta"
                  >
                  @if (message.deliveredDate) {
                    <span title="Delivered Date - {{ message.deliveredDate | date: 'MM/dd/yyyy HH:mm a' }}" class="text-white me-2"><i class="pi pi-verified"></i></span>
                  }
                  @if (message.deferredDate && !message.deliveredDate) {
                    <span title="Carrier did not confirm delivery as of {{ message.deferredDate | date: 'MM/dd/yyyy HH:mm a' }} — message was sent successfully" class="text-white me-2"><i class="pi pi-exclamation-triangle"></i></span>
                  }
                  <button type="button"
                    class="sms-info-btn"
                    (click)="openSmsInfo(message)"
                    title="View SMS details">
                    <i class="pi pi-info-circle"></i>
                  </button>
                </div>
              }
            </div>
          </div>
        }
      </div>
      <!-- Chat Reply Input Section -->
      <div [hidden]="!inboxId" [formGroup]="form1" class="sms-chat-input-container">
        <div class="sms-chat-attach-row">
          <input #smsFileInput type="file" class="mail-file-input" multiple
            accept="image/*,video/*,audio/*,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            (change)="onFileSelected($event)">
            <button type="button" class="attach-btn sms-attach-btn" (click)="smsFileInput.click()" title="Attach file">
              <i class="pi pi-paperclip" aria-hidden="true"></i>
              <span>Attach</span>
            </button>
            @if (uploadedFiles.length) {
              <div class="attachment-grid">
                @for (file of uploadedFiles; track file; let i = $index) {
                  <div class="attachment-card sms-attachment-card">
                    <div class="attachment-card-thumb">
                      @if (isPdf(file)) {
                        <i class="pi pi-file-pdf" aria-hidden="true"></i>
                      }
                      @if (!isPdf(file)) {
                        <i class="pi pi-file" aria-hidden="true"></i>
                      }
                    </div>
                    <div class="text-start">
                      <div class="attachment-card-name" [title]="file.name">{{ file.name }}</div>
                      <div class="attachment-card-size">{{ formatFileSize(file.size) }}</div>
                    </div>
                    <div class="attachment-card-actions">
                      <button type="button" class="btn-attach-view" (click)="viewAttachment(file)">
                        <i class="pi pi-eye" aria-hidden="true"></i>
                      </button>
                      <button type="button" class="btn-attach-delete" (click)="removeAttachment(i)">
                        <i class="pi pi-trash" aria-hidden="true"></i>
                      </button>
                    </div>
                  </div>
                }
              </div>
            }
          </div>
          <!-- Template Dropdown -->
          <div class="sms-chat-template-wrapper">
            <p-dropdown
              [showClear]="true"
              dropdownIcon="fa fa-caret-down"
              appendTo="body"
              [filter]="true"
              filterBy="name"
              class="sms-chat-template-dropdown"
              [options]="msgTemplates"
              formControlName="msgTemplateId"
              optionLabel="name"
              optionValue="msgTemplateId"
              placeholder="Select Template"
              (onChange)="selectTemplate($event)">
            </p-dropdown>
          </div>
          <div class="sms-chat-input-wrapper">
            <textarea
              pInputTextarea
              class="sms-chat-textarea"
              formControlName="mobileText"
              placeholder="Type a message..."
              rows="1"
              [autoResize]="true"
              (keydown.enter)="onChatInputEnter($event)"
              >
              <!-- (keydown.shift.enter)="$event.preventDefault(); insertNewLine()" -->
            </textarea>
            <button
              class="sms-chat-send-btn"
              [disabled]="(!form1.get('mobileText')?.value?.trim() && !uploadedFiles?.length) || formLoading"
              (click)="sendMessageFromChat()"
              [title]="'Send message'">
              @if (!formLoading) {
                <i class="pi pi-send"></i>
              }
              @if (formLoading) {
                <i class="pi pi-spin pi-spinner"></i>
              }
            </button>
          </div>
        </div>
      </div>
    }

    <!-- SMS Detail dialog -->
    <p-dialog
      header="SMS Details"
      [(visible)]="showSmsDetailDialog"
      [modal]="true"
      [style]="{ width: '450px' }"
      appendTo="body"
      [baseZIndex]="12000"
      [draggable]="false">
      @if (loadingSmsDetail) {
        <div class="text-center py-3">
          <i class="pi pi-spin pi-spinner" style="font-size: 1.5rem;"></i>
        </div>
      }
      @if (!loadingSmsDetail && selectedSmsDetail) {
        <div class="sms-detail-dialog">
          @if (selectedSmsDetail._noTrackingId) {
            <div class="mb-3 p-2" style="background:#fff3cd;border-radius:4px;font-size:0.85rem;">
              Delivery status unavailable — this message has no Twilio tracking ID.
            </div>
          }
          @if (selectedSmsDetail.trackingId) {
            <div class="mb-2"><strong>Tracking Id:</strong> {{ selectedSmsDetail.trackingId }}</div>
          }
          <div class="mb-2"><strong>Msg ID:</strong> {{ selectedSmsDetail.msgId }}</div>
          @if (selectedSmsDetail.msgSentId) {
            <div class="mb-2"><strong>Msg Sent ID:</strong> {{ selectedSmsDetail.msgSentId }}</div>
          }
          @if (selectedSmsDetail.from) {
            <div class="mb-2"><strong>From:</strong> {{ selectedSmsDetail.from }}</div>
          }
          @if (selectedSmsDetail.to) {
            <div class="mb-2"><strong>To:</strong> {{ selectedSmsDetail.to }}</div>
          }
          @if (selectedSmsDetail.sentDate) {
            <div class="mb-2"><strong>Sent Date:</strong> {{ formatMessageDate(selectedSmsDetail.sentDate) }}</div>
          }
          <div class="mb-2">
            <strong>Status:</strong>
            @if (selectedSmsDetail._noTrackingId) {
              <span class="text-muted">Not available</span>
            } @else if (selectedSmsDetail.twilioStatus) {
              {{ selectedSmsDetail.statusLabel }} ({{ selectedSmsDetail.twilioStatus }})
            } @else {
              {{ selectedSmsDetail.statusLabel || 'Unknown' }}
            }
          </div>
          @if (selectedSmsDetail.errorCode || selectedSmsDetail.errorMessage) {
            <div class="mb-2">
              <strong>Error:</strong> {{ selectedSmsDetail.errorCode }} {{ selectedSmsDetail.errorMessage }}
            </div>
          }
          @if (selectedSmsDetail.numMedia) {
            <div class="mb-2"><strong>Media Count:</strong> {{ selectedSmsDetail.numMedia }}</div>
          }
          @if (selectedSmsDetail.mobileText) {
            <div class="mb-2">
              <strong>Message:</strong>
              <div class="sms-detail-text">{{ selectedSmsDetail.mobileText }}</div>
            </div>
          }
          @if (selectedSmsDetail.smsAttachments?.length) {
            <div class="mb-2">
              <strong>Attachments:</strong>
              <ul class="sms-detail-attachments">
                @for (att of selectedSmsDetail.smsAttachments; track att) {
                  <li>
                    <a href="{{ att.mediaUrl }}" target="_blank">
                      {{ att.filename || 'Attachment' }} ({{ att.contentType }})
                    </a>
                  </li>
                }
              </ul>
            </div>
          }
        </div>
      }
      <!-- <p-footer>
      <button pButton type="button" label="Close" icon="pi pi-times" (click)="showSmsDetailDialog = false"></button>
    </p-footer> -->
  </p-dialog>

  <div [formGroup]="form1" class="forms w-100 d-block">
    <div class="row m-0">

      <div class="col-lg-12">
        @if (formAlert) {
          <div class="w-100 mb-3">
            <div class="w-100"
              style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
              <p><b>{{formAlert}}</b></p>
            </div>
          </div>
        }
      </div>
      <div class="row">
        <!-- <div class="col-lg-1 btn-custom" *ngIf="inboxId">
        <button pButton [disabled]="!isReplyEnable" class="btn-addt p-button" (click)="replyMail()">Reply
        </button>
      </div>
      <div class="col-lg-1 btn-custom">
        <button pButton [disabled]="!isSendEnable" class="btn-addt p-button" (click)="addAndSendMsg()">Send
        </button>
      </div> -->
      @if (inbox && inbox?.msgFolder !==2) {
        <div class="col-lg-1 btn-custom mb-1">
          <button pButton class="btn-addt p-button" (click)="archiveMsg(inbox)">Archive
          </button>
        </div>
      }
      @if (inbox?.taskAPIList?.length>0 && !fromTask) {
        <div class="col-lg-2 btn-custom">
          <button pButton class="btn-addt p-button" (click)="openViewTask(inbox)">View task
          </button>
        </div>
      }
      @if (inbox) {
        <div class="col-lg-2 btn-custom">
          <button pButton class="btn-addt p-button" (click)="openCreateTask(inbox)">Add task
          </button>
        </div>
      }
      @if (inboxId) {
        <div class="col-lg-4 mb-1 btn-custom btn-sm">
          <app-tag-join-select [tagSource]="120" [tagSourceId]="inboxId" tagType="4"
            (tagsSelectedEvent)="onSmsTagsSelected($event)">
          </app-tag-join-select>
        </div>
      }
    </div>
    <div [hidden]="!isSendEnable">
      <div>
        <label class="fw-bold">To:</label>
        <div class="d-flex mt-3">
          <div class="d-flex align-items-center gap-2">
            <span class="p-float-label required-field w-100 mb-3">
              <p-dropdown class="w-100" [options]="countries" formControlName="mobileCountryCode" optionLabel="name"
              optionValue="dial" placeholder="Country Code"></p-dropdown>
              <label for="mobileCountryCode">Country</label>
              @for (validation of validationMessages.mobileCountryCode; track validation) {
                <span>
                  @if (form1.get('mobileCountryCode').hasError(validation.type) && (form1.get('mobileCountryCode').dirty || form1.get('mobileCountryCode').touched)) {
                    <small class="p-invalid"
                      >{{validation.message}}
                    </small>
                  }
                </span>
              }
            </span>
          </div>
          <div class="d-flex align-items-center gap-2">
            <span class="p-float-label required-field w-100 mb-3">
              <!-- <p-inputMask formControlName="mobileNum" id="mobileNum" mask="(999) 999-9999" type="text">
            </p-inputMask> -->
            <input formControlName="mobileNum" id="mobileNum" type="text" pInputText>
            <label for="mobileNum">Mobile Number</label>
            @for (validation of validationMessages.mobileNum; track validation) {
              <span>
                @if (form1.get('mobileNum').hasError(validation.type) && (form1.get('mobileNum').dirty || form1.get('mobileNum').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
      </div>
    </div>
    <div>
      <div>
        <span class="p-float-label w-75">
          <p-dropdown [showClear]="true" dropdownIcon="fa fa-caret-down" appendTo="body" [filter]="true" filterBy="name" class="w-100" [options]="msgTemplates"
            formControlName="msgTemplateId" optionLabel="name" placeholder="Template"
          (onChange)="selectTemplate($event)"></p-dropdown>
          <label for="msgTemplateId">Select Template</label>
        </span>
      </div>
    </div>
  </div>

  <!--

  <div class="col-lg-12 btn-custom btn-sm">
    <button *ngIf="isSendEnable" pButton class="me-2 p-button-light" style="align-content: end" (click)="cancelReply()">Cancel</button>
    <button pButton [disabled]="!isSendEnable" class="btn-addt p-button-primary" style="align-content: end"
      (click)="addAndSendMsg()">Send
    </button>
  </div> -->
</div>
</div>
<hr>
</div>